import { Box, Flex, HStack, Link, Text, VStack } from '@chakra-ui/react';
import { headingFont } from 'theme/tokens';
import { translate } from 'i18n';
import WhatsAppCta from './WhatsAppCta';

export default function MarketingFooter() {
  return (
    <Box as="footer" bg="gray.900" color="white" px={{ base: 4, md: 8 }} py={16}>
      <Flex
        maxW="1200px"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'center', md: 'flex-start' }}
        gap={10}
      >
        <VStack align={{ base: 'center', md: 'flex-start' }} spacing={4}>
          <Text fontFamily={headingFont} fontWeight="800" fontSize="xl">
            MySportSet
          </Text>
          <Text fontSize="sm" color="gray.400" maxW="280px" textAlign={{ base: 'center', md: 'left' }}>
            {translate('marketing.footer_tagline')}
          </Text>
        </VStack>

        <VStack spacing={3}>
          <Text fontWeight="600" fontSize="sm" textTransform="uppercase" letterSpacing="0.05em">
            {translate('marketing.footer_contact')}
          </Text>
          <WhatsAppCta size="md" />
          <Link href="mailto:contact@mysportset.com" fontSize="sm" color="gray.400" _hover={{ color: 'white' }}>
            contact@mysportset.com
          </Link>
        </VStack>

        <HStack spacing={8}>
          <VStack align="flex-start" spacing={2}>
            <Text fontWeight="600" fontSize="sm" textTransform="uppercase" letterSpacing="0.05em">
              {translate('marketing.footer_product')}
            </Text>
            <Link href="#/marketing/roi-calculator" fontSize="sm" color="gray.400" _hover={{ color: 'white' }}>
              {translate('marketing.nav_roi_calculator')}
            </Link>
            <Link href="#/marketing/migration-kit" fontSize="sm" color="gray.400" _hover={{ color: 'white' }}>
              {translate('marketing.nav_migration_kit')}
            </Link>
            <Link href="#/marketing/referral" fontSize="sm" color="gray.400" _hover={{ color: 'white' }}>
              {translate('marketing.nav_referral')}
            </Link>
          </VStack>
        </HStack>
      </Flex>

      <Text textAlign="center" fontSize="xs" color="gray.600" mt={12}>
        &copy; {new Date().getFullYear()} MySportSet. {translate('marketing.footer_rights')}
      </Text>
    </Box>
  );
}
